import { useEffect } from "react";
import useTimer from "../../hooks/useTimer";

type Props = {
  initialTimeStamp: number;
};

export default function ExamCountDownTimer({ initialTimeStamp }: Props) {
  const [{ days, hours, minutes, seconds }, setInitialTimeStamp] = useTimer();

  useEffect(() => {
    if (initialTimeStamp) {
      setInitialTimeStamp(initialTimeStamp);
    }
    // eslint-disable-next-line
  }, [initialTimeStamp]);

  return (
    <>
      <h5>Time Left:</h5>

      <div className="my-session-timer-container-time-left time-left">
        {days ? (
          <>
            <div className="timer-container-time-left">
              <div className="time-container-time-left">{days}</div>
              <div className="time-container-time-left-text">Days</div>
            </div>
            <div className="time-colon-time-left">:</div>
          </>
        ) : null}

        {hours ? (
          <>
            <div className="timer-container-time-left">
              <div className="time-container-time-left">{hours}</div>
              <div className="time-container-time-left-text">Hours</div>
            </div>
            <div className="time-colon-time-left">:</div>
          </>
        ) : null}

        <div className="timer-container-time-left">
          <div className="time-container-time-left">{minutes}</div>
          <div className="time-container-time-left-text">Minutes</div>
        </div>
        <div className="time-colon-time-left">:</div>

        <div className="timer-container-time-left">
          <div className="time-container-time-left">{seconds}</div>
          <div className="time-container-time-left-text">Seconds</div>
        </div>
      </div>
    </>
  );
}
